/* eslint-disable no-shadow,consistent-return,no-param-reassign,no-console,max-len,no-unused-vars */
import jApiKurikulum from '@/services/jApiKurikulum';
import router from '@/router';

const state = {
};

const mutations = {
};

const actions = {
  async getListCategory({ dispatch }, req) {
    let res;
    try {
      res = await jApiKurikulum.listCategory(req);
    } catch (err) {
      // dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async getListPegawai({ dispatch }, req) {
    let res;
    try {
      res = await jApiKurikulum.listPegawai(req);
    } catch (err) {
      // dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async getListKelas({ dispatch }, req) {
    let res;
    try {
      res = await jApiKurikulum.listKelas(req);
    } catch (err) {
      // dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async getListSiswa({ dispatch }, { reqData, callback }) {
    try {
      const listSiswa = await jApiKurikulum.getSiswa(reqData);
      const res = listSiswa.data;
      res.forEach((lab, index) => {
        res[index].label = lab.name;
      });
      callback(null, res);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async getAdditionalInfo({ dispatch }, req) {
    let res;
    try {
      res = await jApiKurikulum.getAdditionalInfo(req);
    } catch (err) {
      // dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  // Admin Pembelajaran ----------------------------------------------------------------------
  // Requester
  async createAdminPembelajaran({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.createAdminPembelajaran(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateAdminPembelajaran({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.updateAdminPembelajaran(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async submitAdminPembelajaran({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.submitAdminPembelajaran(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteAdminPembelajaran({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.deleteAdminPembelajaran(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async detailAdminPembelajaran({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.detailAdminPembelajaran(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Approver
  async approveAdminPembelajaranApp({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.approveAdminPembelajaranApp(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async rejectAdminPembelajaranApp({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.rejectAdminPembelajaranApp(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Kepegawaian ----------------------------------------------------------------------
  async createPegawai({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.createPegawai(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updatePegawai({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.updatePegawai(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async detailPegawai({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.detailPegawai(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deletePegawai({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.deletePegawai(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async changePasswdPegawai({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.changePasswdPegawai(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Sertifikasi ----------------------------------------------------------------------
  async createSertifikasi({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.createSertifikasi(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateSertifikasi({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.updateSertifikasi(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteSertifikasi({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.deleteSertifikasi(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Pendidikan ----------------------------------------------------------------------
  async createPendidikan({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.createPendidikan(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updatePendidikan({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.updatePendidikan(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deletePendidikan({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.deletePendidikan(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Kompetensi ----------------------------------------------------------------------
  async createKompetensi({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.createKompetensi(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateKompetensi({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.updateKompetensi(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteKompetensi({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.deleteKompetensi(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Anak ----------------------------------------------------------------------
  async createAnak({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.createAnak(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateAnak({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.updateAnak(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteAnak({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.deleteAnak(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Buku ----------------------------------------------------------------------
  async createBuku({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.createBuku(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateBuku({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.updateBuku(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteBuku({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.deleteBuku(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Diklat ----------------------------------------------------------------------
  async createDiklat({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.createDiklat(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateDiklat({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.updateDiklat(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteDiklat({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.deleteDiklat(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Karya Tulis ----------------------------------------------------------------------
  async createKaryaTulis({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.createKaryaTulis(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateKaryaTulis({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.updateKaryaTulis(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteKaryaTulis({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.deleteKaryaTulis(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Beasiswa ----------------------------------------------------------------------
  async createBeasiswa({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.createBeasiswa(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateBeasiswa({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.updateBeasiswa(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteBeasiswa({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.deleteBeasiswa(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Tunjangan ----------------------------------------------------------------------
  async createTunjangan({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.createTunjangan(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateTunjangan({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.updateTunjangan(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteTunjangan({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.deleteTunjangan(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Kesejahteraan ----------------------------------------------------------------------
  async createKesejahteraan({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.createKesejahteraan(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateKesejahteraan({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.updateKesejahteraan(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteKesejahteraan({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.deleteKesejahteraan(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Tugas Tambahan ----------------------------------------------------------------------
  async createTugasTambahan({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.createTugasTambahan(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateTugasTambahan({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.updateTugasTambahan(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteTugasTambahan({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.deleteTugasTambahan(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Inpassing Non PNS ----------------------------------------------------------------------
  async createInpassing({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.createInpassing(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateInpassing({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.updateInpassing(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteInpassing({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.deleteInpassing(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Penghargaan ----------------------------------------------------------------------
  async createPenghargaan({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.createPenghargaan(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updatePenghargaan({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.updatePenghargaan(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deletePenghargaan({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.deletePenghargaan(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Nilai Tes ----------------------------------------------------------------------
  async createNilaiTes({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.createNilaiTes(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateNilaiTes({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.updateNilaiTes(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteNilaiTes({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.deleteNilaiTes(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Gaji Berkala ----------------------------------------------------------------------
  async createGajiBerkala({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.createGajiBerkala(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateGajiBerkala({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.updateGajiBerkala(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteGajiBerkala({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.deleteGajiBerkala(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Jabatan Pendidik ----------------------------------------------------------------------
  async createJabatanPendidik({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.createJabatanPendidik(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateJabatanPendidik({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.updateJabatanPendidik(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteJabatanPendidik({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.deleteJabatanPendidik(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Golongan ----------------------------------------------------------------------
  async createGolongan({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.createGolongan(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateGolongan({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.updateGolongan(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteGolongan({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.deleteGolongan(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Jabatan Fungsional ----------------------------------------------------------------------
  async createJabatanFungsional({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.createJabatanFungsional(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateJabatanFungsional({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.updateJabatanFungsional(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteJabatanFungsional({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.deleteJabatanFungsional(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Karir Guru ----------------------------------------------------------------------
  async createKarirGuru({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.createKarirGuru(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateKarirGuru({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.updateKarirGuru(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteKarirGuru({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.deleteKarirGuru(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Role -------------------------------------------------------------------------------------
  async getRole({ dispatch }, req) {
    let res;
    try {
      res = await jApiKurikulum.getRole(req);
    } catch (err) {
      // dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async updateRole({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.updateRole(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async checkNotification({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.checkNotification(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async listProdi({ dispatch }) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKurikulum.listProdi();
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // LOG -------------------------------------------------------------------------------------
  async getLog({ dispatch }, req) {
    let res;
    try {
      res = await jApiKurikulum.getLog(req);
    } catch (err) {
      // dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/stores/jStoreKurikulum.js